import { render, staticRenderFns } from "./copyTeamStaffDialog.vue?vue&type=template&id=1148e17c&scoped=true"
import script from "./copyTeamStaffDialog.vue?vue&type=script&lang=js"
export * from "./copyTeamStaffDialog.vue?vue&type=script&lang=js"
import style0 from "./copyTeamStaffDialog.vue?vue&type=style&index=0&id=1148e17c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1148e17c",
  null
  
)

export default component.exports